import {
  SITE_FEATURE_FLAGS,
  type SiteFeatureFlag,
  type SiteFeatures,
} from '../models/domainModels';

/**
 * PATCH body: only the flags being set.
 *
 * An absent key leaves the stored flag untouched, so naming a flag that did not
 * change would record an explicit `false` for one that was never set.
 */
export type SiteFeaturesPatchRequest = { readonly [K in SiteFeatureFlag]?: boolean };

/** Flags whose edited value differs from what is stored, in vocabulary order. */
export const changedFlags = (
  stored: SiteFeatures,
  edited: SiteFeatures
): readonly SiteFeatureFlag[] =>
  SITE_FEATURE_FLAGS.filter((flag) => stored[flag] !== edited[flag]);

export const buildFeaturesPatch = (
  stored: SiteFeatures,
  edited: SiteFeatures
): SiteFeaturesPatchRequest =>
  Object.fromEntries(changedFlags(stored, edited).map((flag) => [flag, edited[flag]]));
